import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=68fc3b99&scoped=true&"
import script from "./Location.vue?vue&type=script&lang=js&"
export * from "./Location.vue?vue&type=script&lang=js&"
import style0 from "./Location.vue?vue&type=style&index=0&id=68fc3b99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc3b99",
  null
  
)

export default component.exports